module.exports = __webpack_public_path__ + "static/media/Amelia_Island_FL_History_Museum_Spanish_Port_building_window_mural_2.ece0f3f2.webp";